import {
  AfterEffects,
  Aws,
  Claude,
  Figma,
  Framer,
  Gsap,
  Illustrator,
  Java,
  Jira,
  Kotlin,
  Nestjs,
  Nextjs,
  Photoshop,
  React,
  Slack,
  Vercel,
  Webflow,
  WordPress,
} from '@/components/SvgIcons/Technologies';

export interface TechStackItem {
  id: string;
  name: string;
  icon: React.ComponentType<{ props?: React.SVGProps<SVGSVGElement>; size?: string | number }>;
  background: string;
  isDark: boolean;
}

export const techStackItems: TechStackItem[] = [
  {
    id: 'after-effects',
    name: 'Adobe After Effects',
    icon: AfterEffects,
    background: '#00005B',
    isDark: true,
  },
  {
    id: 'illustrator',
    name: 'Adobe Illustrator',
    icon: Illustrator,
    background: '#330000',
    isDark: true,
  },
  {
    id: 'aws',
    name: 'Amazon Web Services',
    icon: Aws,
    background: 'linear-gradient(211deg, #F0F0F0 0%, #FFF 100%)',
    isDark: false,
  },
  {
    id: 'claude',
    name: 'Claude',
    icon: Claude,
    background: '#D97757',
    isDark: false,
  },
  {
    id: 'figma',
    name: 'Figma',
    icon: Figma,
    background: 'linear-gradient(211deg, #F0F0F0 0%, #FFF 100%)',
    isDark: false,
  },
  {
    id: 'framer',
    name: 'Framer',
    icon: Framer,
    background: '#513EFF',
    isDark: true,
  },
  {
    id: 'gsap',
    name: 'GSAP',
    icon: Gsap,
    background: '#0DE345',
    isDark: false,
  },
  {
    id: 'java',
    name: 'Java',
    icon: Java,
    background: 'linear-gradient(211deg, #F0F0F0 0%, #FFF 100%)',
    isDark: false,
  },
  {
    id: 'jira',
    name: 'Jira',
    icon: Jira,
    background: '#1A2E51',
    isDark: true,
  },
  {
    id: 'kotlin',
    name: 'Kotlin',
    icon: Kotlin,
    background: '#844EFD',
    isDark: true,
  },
  {
    id: 'nestjs',
    name: 'Nest.js',
    icon: Nestjs,
    background: '#E0234E',
    isDark: true,
  },
  {
    id: 'nextjs',
    name: 'Next.js',
    icon: Nextjs,
    background: 'linear-gradient(211deg, #F0F0F0 0%, #FFF 100%)',
    isDark: false,
  },
  {
    id: 'photoshop',
    name: 'Photoshop',
    icon: Photoshop,
    background: '#001E36',
    isDark: true,
  },
  {
    id: 'react',
    name: 'React',
    icon: React,
    background: '#61DAFB',
    isDark: false,
  },
  {
    id: 'slack',
    name: 'Slack',
    icon: Slack,
    background: 'linear-gradient(211deg, #F0F0F0 0%, #FFF 100%)',
    isDark: false,
  },
  {
    id: 'wordpress',
    name: 'WordPress',
    icon: WordPress,
    background: '#464342',
    isDark: true,
  },
  {
    id: 'webflow',
    name: 'Webflow',
    icon: Webflow,
    background: '#146EF5',
    isDark: true,
  },
  {
    id: 'vercel',
    name: 'Vercel',
    icon: Vercel,
    background: 'linear-gradient(211deg, #F0F0F0 0%, #FFF 100%)',
    isDark: false,
  },
];
